import type { FC } from "react";

import { Modal } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import ModalContent from "app/pages/sales-intelligence/common-components/ContactUsModal/modalContent/ModalContent";

import { quotaModalConfig } from "./styles";

interface QuotaContactAdminModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export const QuotaContactAdminModal: FC<QuotaContactAdminModalProps> = ({ isOpen, onClose }) => {
    return (
        <Modal
            isOpen={isOpen}
            customStyles={quotaModalConfig}
            onRequestClose={onClose}
        >
            <ModalContent
                title={translate("si.common.thanks")}
                subTitle={translate("si.quota.modal.admin.description")}
                buttonText={translate("si.modal.get_feature.success.btn.close")}
                onClick={onClose}
            />
        </Modal>
    );
};
